module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "id": "dashboardCards",
      "gutter": ""
    }
  }, _vm._l((_vm.chunkedOrder), function(chunk, chunkIndex) {
    return _c('mu-col', {
      key: 'card-chunk-group-' + chunkIndex,
      attrs: {
        "width": "100",
        "desktop": _vm.desktopWidth,
        "tablet": "50"
      }
    }, _vm._l((chunk), function(item, chunkedIndex) {
      return _c('div', {
        key: 'card-order-' + chunkedIndex
      }, [(item.name === 'ACTIVITY') ? _c('div', [_c('activity-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "bmr": _vm.$store.state.user.stats.bmr
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'BLOOD_GLUCOSE') ? _c('div', [_c('blood-glucose-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "blood-glucose": _vm.$store.state.user.settings.blood_glucose,
          "hba1c": _vm.$store.state.user.settings.hba1c
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'CHOLESTEROL') ? _c('div', [_c('cholesterol-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "blood_glucose": _vm.$store.state.user.settings.blood_glucose
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'WEIGHT') ? _c('div', [_c('weight-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "height": _vm.$store.state.user.settings.height,
          "waist": _vm.$store.state.user.settings.waist,
          "weight": _vm.$store.state.user.settings.weight
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'KETONES') ? _c('div', [_c('ketones-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "blood-glucose": _vm.$store.state.user.settings.blood_glucose
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'BLOOD_PRESSURE') ? _c('div', [_c('blood-pressure-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'SLEEP') ? _c('div', [_c('sleep-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'MOOD') ? _c('div', [(_vm.$store.state.moodList) ? _c('mood-input', {
        staticClass: "card-spacing bottom"
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.name === 'MEDICATION') ? _c('div', [_c('medication-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'INSULIN') ? _c('div', [_c('insulin-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'NUTRITION') ? _c('div', [_c('nutrition-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e()])
    }), 0)
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-176e36f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Cards.vue
// module id = 3061
// module chunks = 1